module.exports = __webpack_public_path__ + "static/media/ibd_shoulder2.6c88ccb8.png";